<template>
  <div class="container">
    <slot />
    <dl class="mb15 part23 radius8 ohide vh10 C666 flex initial nowrap">
      <dd class="flex1 scroll relative zIndex1" :class="{ BGwhite: KCType == 1 }">
        <iframe :src="FilePath" v-if="KCType == 1" frameborder="0" style="width: 100%; min-height: 99%"></iframe>
        <div v-if="KCType == 2" id="video"></div>
        <!-- <video
          v-if="KCType == 2"
          id="video3"
          ref="video"
          style="width: 100%"
          controls=""
          controlslist="nodownload nofullscreen"
        >
         <source :src="FilePath" type="application/x-mpegURL" />
          您的浏览器不支持 Video 元素。 
        </video> -->
      </dd>

      <dt class="scroll">
        <div class="scroll-tit dtTitle">
          <p class="size18 pad10 ml10">课程列表</p>
        </div>
        <div class="pad20">
          <ul class="scroll-list mb20" :class="{ on: ch.open }" v-for="(ch, chIndex) in list" :key="chIndex">
            <p class="ellipsis on-title" @click="ch.open = !ch.open">
              第{{ chIndex + 1 }}章 &nbsp; {{ ch.CatalogName }}
              <i class="el-icon-arrow-down"></i>
            </p>

            <!-- KCType 1图文 2视频  -->
            <div v-for="(chapter, index) in ch.Chapters" :key="index" class="bdbt"
              :class="[index + 1 == ch.Chapters.length ? 'noBd' : '']">
              <div style="position: relative" class="chapterDiv" :class="[
                $route.query.ChapterID == chapter.ChapterID ? 'Con' : '',
              ]" @click="switchVideo(chapter, list, chIndex, index)">
                <div class="l">
                  <i class="el-icon-success size20" v-if="chapter.StudyProgress == 100"></i>
                  <i class="circle" v-else-if="chapter.StudyProgress == 0"></i>
                  <i class="circle half" v-else></i>
                </div>
                <p>第{{ index + 1 }}节- {{ chapter.ChapterName }}</p>
              </div>
            </div>
          </ul>
        </div>
        <div class="pad30"></div>
      </dt>
    </dl>
  </div>
</template>

<script>
/* eslint-disable */
import VueMarkdown from "vue-markdown";
import { Course_GetChapterFile, Course_StudyCount } from "@/api/course";
export default {
  name: "ChapterPlay",
  components: {
    VueMarkdown,
  },
  props: {
    chapterList: Array,
    data: Object,
  },
  data() {
    return {
      FilePath: "",
      control: false,
      KCType: 1, // 1图文 2视频
      player: null,
      isEnd: 0,
      LastDuration: 0,
      StudyTime: 0,
      PlayTimes: [],
      duration: 0,
      totalPlayTimes: [],
      spot: [],
      currentIndex: 0,
      videoPlayWatcher: null,
      currentVideo: 0,
      currentVideoTime: 0,
      spotTimeArr: [],
      showIndex: 0,
    };
  },

  mounted() { },
  methods: {
    isUnlocked(listData, index, chIndex) {
      let item = listData[index]
      let falg = false
      if (index == 0 && chIndex == 0) {
        falg = true
      }
      if (chIndex > 0 && item.Chapters[chIndex - 1].StudyProgress == 100) {
        falg = true
      }
      if (chIndex == 0 && index > 0 && listData[index - 1].Chapters && listData[index - 1].Chapters[listData[index - 1].Chapters.length - 1].StudyProgress == 100) {
        falg = true

      }
      return falg
    },
    jump(item, type) {
      console.log(item);
      let time = item.start_time / 1000;
      this.currentVideoTime = item.start_time;
      this.player.videoSeek(time);
      this.currentVideo = type == 1 ? item.pid : item.chapter_name;
      // video.ontimeupdate = (e) => {
      //   console.log(e)
      //   // 这里可以在进度条变化的时候打印视频播放的位置
      //   new Date('714163.3000000715').getSeconds()
      // }
    },
    formatMilliseconds(milliseconds) {
      // 确保输入是数字
      const ms = Number(milliseconds);

      // 计算总秒数
      const totalSeconds = Math.floor(ms / 1000);

      // 计算分钟和秒
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      // 格式化为两位数，不足补零
      const formattedMinutes = String(minutes).padStart(2, "0");
      const formattedSeconds = String(seconds).padStart(2, "0");

      return `${formattedMinutes}:${formattedSeconds}`;
    },

    watchTimeAndSetActive() {
      const _this = this;
      // this.player.addListener('play', function () {
      _this.currentVideoTime = _this.player.time;

      _this.videoPlayWatcher = setInterval(() => {
        // console.log(123)
        const _time = Number(_this.currentVideoTime);
        _this.currentVideoTime = _time + 1;
        let end = 0;
        for (let i = 0; i < _this.spotTimeArr.length; i++) {
          if (_this.currentVideoTime >= _this.spotTimeArr[i]) {
            // console.log(i)
            end = i;
          }
        }
        // console.log(end);
        _this.showIndex = end;
      }, 1000);
      // })
    },
    getFile(item) {
      const { Duration, ChapterID } = item;
      this.duration = Duration;
      this.$router.push({
        query: { ...this.$route.query, ChapterID: ChapterID },
      });
      this.getFilUrl();
    },
    setPlayBar(time) {
      time = parseInt(time);
      const list = [time];
      for (let item of this.totalPlayTimes || []) {
        for (let i = item.ST; i <= item.ET; i++) {
          if (!list.includes(i)) {
            list.push(i);
          }
        }
      }
      list.sort((a, b) => a - b);
      const layTimes = [{ ST: 0, ET: 0 }];
      let index = 0;
      for (let item of list) {
        if (layTimes[index].ET == 0 || layTimes[index].ET + 1 == item) {
          layTimes[index].ET = item;
        } else {
          index++;
          layTimes.push({ ST: item, ET: item });
        }
      }
      this.totalPlayTimes = layTimes;
      if (!this.duration || this.duration == 0) {
        return;
      }
      let myBar = document.getElementById("myBar");
      let html = "";
      for (let index in layTimes) {
        const { ST, ET } = layTimes[index];
        const left = ST / this.duration;
        const width = (ET - ST) / this.duration;
        html += `
          <p style="left:${left * 100}%;width:${width * 100 + 1.2}%"></p>
        `;
      }
      myBar.innerHTML = html;
    },
    setTime(bool = true) {
      if (bool === false && this.$store.state.timer) {
        clearInterval(this.$store.state.timer);
        clearTimeout(this.$store.state.timer);
        this.$store.state.timer = null;
      }
      if (bool && !this.$store.state.timer) {
        this.$store.state.timer = setInterval(() => {
          if (this.$route.name !== "chapterDetail") {
            this.player = null;
            this.setTime(false);
            return;
          }
          // KCType 1图文 2视频
          if (this.StudyTime < 10) {
            this.StudyTime++;
          }
          if (this.StudyTime % 10 == 0) {
            // 图文时间监听

            let arr =
              this.PlayTimes.length > 10
                ? this.PlayTimes.slice(-10)
                : this.PlayTimes;
            Course_StudyCount({
              ...this.$route.query,
              PlayTimes: this.KCType == 1 ? [] : arr,
              StudyDuration: this.StudyTime,
            }).then(({ data }) => {
              // const { KC_StudyProgress, ZJ_StudyProgress } = data;
              // this.$emit("setprogress", KC_StudyProgress, ZJ_StudyProgress);
              this.StudyTime = 0;
              this.PlayTimes = [];
            });
          }
        }, 1000);
      }
    },

    getFilUrl() {
      // window.demoPlayer = this.player
      this.StudyTime = 0;
      this.setTime(false);
      this.isEnd = 0;
      this.player = null;
      this.PlayTimes = [];
      document.getElementById("app").scrollTop = 0;
      const timeRecord = () => {
        if (
          this.$route.name !== "chapterDetail" ||
          (this.$route.name == "chapterDetail" && !this.$route.query.ChapterID)
        ) {
          this.player = null;
          this.setTime(false);
          return;
        }
      };
      Course_GetChapterFile({
        CourseID: this.$route.query.CourseID,
        ChapterID: this.$route.query.ChapterID,
      }).then((res) => {
        const {
          FilePath,
          ChapterID,
          ChapterName,
          Duration,
          LastDuration,
          MaxDuration,
        } = res.data;
        this.LastDuration = LastDuration;
        this.totalPlayTimes = [];
        this.FilePath = FilePath;

        const KCType = Duration > 0 ? 2 : 1;
        this.KCType = KCType;

        // KCType 1图文 2视频
        this.setTime(true);
        this.$nextTick(() => {
          if (KCType == 2) {
            window.loadHandler = () => {
              this.player.addListener("time", (v) => {
                // 监听播放时间
                this.setTime(true);
                if (this.KCType !== 2) {
                  this.player = null;
                  return;
                }
                const LastDuration = v;

                if (!this.PlayTimes.includes(parseInt(this.currentVideoTime))) {
                  this.PlayTimes.push(parseInt(this.currentVideoTime));
                }
                this.LastDuration = LastDuration;
                if (this.PlayTimes.length >= 10) {
                  timeRecord();
                } else {
                  this.setPlayBar(v);
                }
              });
              // 监听是否暂停了
              this.player.addListener("paused", (t) => {
                // clearInterval(this.videoPlayWatcher)
                // this.videoPlayWatcher = null
                this.setTime(false);
                console.log("暂停了");
              });
              this.player.addListener("play", () => {
                // 播放结束
                this.setTime(true);
                if (this.videoPlayWatcher) {
                  clearInterval(this.videoPlayWatcher);
                  this.videoPlayWatcher = null;
                }
                this.currentVideoTime = this.player.time;
                // console.log(this.currentVideoTime)
                this.watchTimeAndSetActive();
                console.log("我播放了");
              });
              this.player.addListener("finish", () => {
                clearInterval(this.videoPlayWatcher);
                this.videoPlayWatcher = null;
                console.log("结束了");
              });
              this.player.addListener("ended", () => {
                // 播放结束
                this.isEnd = 1;
                Course_StudyCount({
                  ...this.$route.query,
                  PlayTimes: this.PlayTimes,
                  StudyDuration: this.StudyTime,
                }).then(({ data }) => {
                  this.StudyTime = 0;
                  this.PlayTimes = [];
                });
                this.setTime(false);
                timeRecord();
              });
              this.player.addListener("controlBar", (b) => {
                this.control = b;
              });
              // this.player.addListener('full', (b) => { })
            };
            var videoObject = {
              container: "#video",
              variable: "this.player", // 该属性必需设置，值等于下面的new chplayer()的对象
              autoplay: true,
              html5m3u8: true,
              flashplayer: false,
              config: "",
              promptSpot: [],
              seek: LastDuration,
              loaded: "loadHandler",
              video: FilePath, // 视频地址
              // poster: require('@/assets/img/banner5.png'),
            };
            this.player = new ckplayer(videoObject);
            if (
              this.chapterDetail.StudyProgress < 100) {
              this.player.ckplayerConfig['config']['timeScheduleAdjust'] = 0
            }
          }
        });
      });
    },
    // 将视频时长(秒)转化为时分秒的形式
    getTime(value) {
      let secondTime = parseInt(value); // 秒
      let minuteTime = 0; // 分
      let hourTime = 0; // 时
      if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取余，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60);
          //获取小时后取余的分，获取分钟除以60取余的分
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      //若秒数是个位数，前面用0补齐
      secondTime = secondTime < 10 ? "0" + secondTime : secondTime;
      var result = "" + secondTime + "";
      if (minuteTime > 0) {
        //若分钟数是个位数，前面用0补齐
        minuteTime = minuteTime < 10 ? "0" + minuteTime : minuteTime;
        result = "" + minuteTime + ":" + result;
      } else {
        //若分钟数为0，用"00"表示
        result = "" + "00" + ":" + result;
      }

      if (hourTime > 0) {
        //若小时数是个位数，前面用0补齐
        hourTime = hourTime < 10 ? "0" + hourTime : hourTime;
        result = "" + hourTime + ":" + result;
      } else {
        //若小时数为0，用"00"表示
        result = "" + "00" + ":" + result;
      }
      return result;
    },
    setSeekTime(item) {
      // console.log(item)
      this.currentVideoTime = item.time;
      this.player.videoSeek(item.time);
    },
    switchVideo(ch, listData, index, chIndex) {
      if (!this.data.IsBuyed) {
        if (!ch.IsFree) {
          this.$message({
            message: "该章节为付费章节，请购买后再学习",
            type: "warning",
          });
          return;
        }
      }
      if (!this.isUnlocked(listData, index, chIndex)) {
        this.$message({
          message: "请先完成前置章节再学习吧",
          type: "warning",
        });
        return;
      }

      Course_StudyCount({
        ...this.$route.query,
        PlayTimes: this.PlayTimes,
        StudyDuration: this.PlayTimes.length,
      }).then(({ data }) => {
        this.StudyTime = 0;
        this.PlayTimes = [];
        const { Duration, ChapterID } = ch;
        this.duration = Duration;
        this.$router.push({
          query: { ...this.$route.query, ChapterID: ChapterID },
        });
        this.getFilUrl();
      });
    },
  },
  created() {
    this.list = this.chapterList.map((item, index) => {
      const { Duration } =
        item.Chapters.find(
          ({ ChapterID }) => ChapterID == this.$route.query.ChapterID
        ) || {};
      if (Duration) {
        this.duration = Duration;
      }
      return {
        ...item,
        open: item.Chapters.find(
          (item) => item.ChapterID == this.$route.query.ChapterID
        ),
      };
    });
    if (!this.$route.query.ChapterID) {
      this.currentIndex = 0;
    } else {
      const index = this.list[0]["Chapters"].findIndex((item) => {
        return item.ChapterID == this.$route.query.ChapterID;
      });
      if (index != -1) {
        this.currentIndex = index;
      } else {
        this.currentIndex = 0;
      }
    }

    this.getFilUrl();
  },
  watch: {
    // '$route.query.ChapterID' (v) {
    //   location.reload()
    // },
    chapterList: {
      deep: true,
      handler(v) {
        this.list = v.map((item, index) => {
          return {
            ...item,
            open: item.Chapters.find(
              (item) => item.ChapterID == this.$route.query.ChapterID
            ),
          };
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
// .pausecenter-canvas {
//   width: 80px !important;
//   height: 80px !important;
// }
.circle {
  width: 16px;
  height: 16px;
  display: block;
  margin-right: 5px;
  // box-shadow: 0 0 0 1px #666;
  border: solid 1px #1a7afb;
  overflow: hidden;
  border-radius: 50%;
  position: relative;
}

.half::before {
  content: "";
  display: block;
  width: 50%;
  height: 100%;
  background: #1a7afb;
}

.el-icon-success {
  color: #1a7afb;
  margin-right: 1px;
}

.part23 {
  // background: #ffffff;
}

.container {
  .flex1 {
    background: #f6f8fc;
  }

  .scroll {
    width: 340px !important;
    height: 800px !important;
  }

  #video {
    flex: 1;
    height: 800px;
  }
}

.auto-height {
  height: 100%;
}

.Title {
  padding: 0 10px;
  font-size: 14px;

  .topics {
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 16px;
    background: #e3edff;
    color: #376ff6;
    height: 26px;
    line-height: 22px;
  }

  .keywords {
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 16px;
    background: #f1f4f6;
    color: #999999;
    height: 26px;
    line-height: 22px;
  }
}

.ckplayer {

  .timeprogress,
  [class*="loadprogress"] {
    display: none !important;
  }
}

.ckplayer .progress-played {
  background-color: #ff4444;
}

.ckplayer .progress-loaded {
  background-color: #fff;
}

.scroll-list {
  border-radius: 10px;
  border: 1px solid #e9ecf0;
}

.on-title {
  height: 67px !important;
  font-size: 16px !important;
  font-weight: bold;
  color: #333333 !important;
  background: #f6f8fc !important;
}

.on {
  .on-title {
    height: 67px !important;
    font-size: 16px !important;
    font-weight: bold;
    color: #333333 !important;
    background: #f6f8fc !important;

    i {
      transform: rotate(180deg);
    }
  }
}

.bdbt {}

.noBd {
  border-bottom: 0px;
}

.chapterDiv {
  display: none;
  align-items: center;
  padding: 10px 20px;
  margin: 10px 0;
  cursor: pointer;

  p {
    margin-left: 5px;
    font-size: 16px;
    color: #666666;
    max-width: 249px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &:hover {
    p {
      color: #1a7afb;
      border-bottom: 1px solid #1a7afb;
    }
  }

  .l {
    img {
      max-width: 14px;
      width: 14px;
      height: 14px;
      margin-left: 1px;
    }
  }
}

.Con p {
  color: #1a7afb;
  border-bottom: 1px solid #1a7afb;
}

.part23 ul li {
  padding-left: 36px;
  padding-bottom: 10px;
  padding-top: 10px;
}

.part23 ul.on .chapterDiv {
  display: flex;
  border-bottom: 1px solid #f5f5f5;

}

.part23 ul li {
  padding-right: 40px;
}

.scroll {
  background: #fff;

  .scroll-tit {
    display: flex;
    align-items: center;
    color: #333333;
    cursor: pointer;
    font-size: 18px;
    height: 60px;

    .active {
      color: #1a7afb;
    }
  }

  ul {
    //  border-bottom: 2px dashed #f5f5f5;
  }

  ul.on p.ellipsis {
    color: #376ff6;
    background: #f5f5f5;
  }

  ul:hover p.ellipsis {
    color: #376ff6;
    background: #f5f5f5;
  }

  ul.on p.ellipsis i,
  ul:hover p.ellipsis i {
    color: #888;
  }
}

.r-content {
  width: 100%;

  .active {
    p {
      color: #000000 !important;
    }
  }

  .content-item {
    padding: 10px 20px;
    cursor: pointer;

    // margin-bottom: 33px;
    p {
      margin-bottom: 9px;
      font-size: 14px;
      color: #999999;
      line-height: 26px;
      font-weight: 700;
    }

    span {
      font-size: 16px;
      color: #333333;
      line-height: 26px;
    }

    &.zhaiyao {

      h1,
      h2 {
        margin-bottom: 5px;
        font-family: HarmonyOS_Sans_SC_Medium;
        font-size: 16px;
        color: #333333;
        line-height: 26px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      h3,
      h4,
      h5,
      h6,
      p {
        font-family: HarmonyOS_Sans_SC;
        font-size: 14px;
        color: #333333;
        line-height: 26px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        font-weight: normal;
      }
    }
  }
}

.preview-container {
  width: 100%;
  margin-top: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  background: #fff;
  border-radius: 4px 4px 4px 4px;
  padding: 20px;

  .pre-content {
    display: flex;
    align-items: flex-start;

    .pre-item {
      cursor: pointer;
      width: 180px;
      flex-shrink: 0;

      &.active {
        .pre-mid {
          .time {
            background: #1a7afb;

            color: #fff;
          }
        }
      }

      .pre-top {
        margin-bottom: 9px;
        width: 160px;
        height: 90px;
        background-color: #333333;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .pre-mid {
        display: flex;
        align-items: center;
        margin-bottom: 9px;
        width: 100%;

        .time {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          // width: 45px;
          padding: 0 3px;
          height: 20px;
          background: #e3edff;
          border-radius: 4px 4px 4px 4px;
          color: #1a7afb;
        }

        .line {
          flex-grow: 1;
          height: 2px;
          background: #dddddd;
        }
      }

      .pre-bot {
        width: 160px;
        flex-wrap: wrap;
        font-size: 14px;
        color: #333333;
        overflow-wrap: break-word;
        word-break: break-word;
        word-wrap: break-word;
      }
    }
  }
}

.dtTitle {
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 20px;
    left: 0;
    width: 6px;
    height: 20px;
    background: #1d79ff;
    border-radius: 3px;}
}
</style>
